// @ts-nocheck
import { getBit, setBit } from "../helpers/binary-helpers.js";
export class Input {
    isPressingUp = false;
    isPressingDown = false;
    isPressingLeft = false;
    isPressingRight = false;
    isPressingSelect = false;
    isPressingStart = false;
    isPressingA = false;
    isPressingB = false;
    isPollingDirections = false;
    isPollingButtons = false;
    setInputToCheck(byte) {
        this.isPollingButtons = getBit(byte, 4) === 1;
        this.isPollingDirections = getBit(byte, 5) === 1;
    }
    reportInput() {
        let inputValue = 0b1111;
        if (this.isPollingDirections) {
            inputValue = setBit(inputValue, 0, this.isPressingRight ? 0 : 1);
            inputValue = setBit(inputValue, 1, this.isPressingLeft ? 0 : 1);
            inputValue = setBit(inputValue, 2, this.isPressingUp ? 0 : 1);
            inputValue = setBit(inputValue, 3, this.isPressingDown ? 0 : 1);
        }
        if (this.isPollingButtons) {
            inputValue = setBit(inputValue, 0, this.isPressingA ? 0 : 1);
            inputValue = setBit(inputValue, 1, this.isPressingB ? 0 : 1);
            inputValue = setBit(inputValue, 2, this.isPressingSelect ? 0 : 1);
            inputValue = setBit(inputValue, 3, this.isPressingStart ? 0 : 1);
        }
        inputValue = setBit(inputValue, 4, this.isPollingButtons ? 0 : 1);
        inputValue = setBit(inputValue, 5, this.isPollingDirections ? 0 : 1);
        return inputValue;
    }
}
// MultiNostalgia patch: no module-level `input` singleton. Upstream
// exported one shared `Input` that Memory read at $FF00 and every
// Gameboy pointed its `input` field at — so two Gameboys in one process
// shared one controller (crosstalk on read, and loadState on instance B
// clobbered the flags instance A was reading). Each Gameboy now owns its
// own `Input`, threaded into its Memory and input managers. This is the
// property the fidelity rig needs to run two GBs in lockstep.
//# sourceMappingURL=input.js.map